import {
  QueryBuilderConfig,
  QueryBuilderValue,
} from "../../data-model/queryBuilder";
import QueryBuilderGroup from "./QueryBuilderGroup";
import { useQueryBuilder } from "./useQueryBuilder";

interface QueryBuilderProps {
  value: QueryBuilderValue;
  onChange: (value: QueryBuilderValue) => void;
  config: QueryBuilderConfig;
  className?: string;
}

const QueryBuilder = ({
  value,
  onChange,
  config,
  className = "",
}: QueryBuilderProps) => {
  const {
    updateConditionField,
    updateConditionOperator,
    updateConditionValue,
    toggleGroupConjunction,
    addCondition,
    addNestedGroup,
    removeNode,
  } = useQueryBuilder(value, onChange, config);

  return (
    <div className={className}>
      <QueryBuilderGroup
        group={value}
        config={config}
        isRoot
        onFieldChange={updateConditionField}
        onOperatorChange={updateConditionOperator}
        onValueChange={updateConditionValue}
        onToggleConjunction={toggleGroupConjunction}
        onAddCondition={addCondition}
        onAddNestedGroup={addNestedGroup}
        onRemove={removeNode}
      />
    </div>
  );
};

export default QueryBuilder;
